module.exports = __webpack_public_path__ + "img/rotate-right-1.7de39839.svg";